import React from "react";
import { Box, Link, Paper, Typography } from "@mui/material";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import PageHeader from "../components/PageHeader";

const SUPPORT_EMAIL = "n.anderson@qub.ac.uk";

export default function Help() {
  return (
    <Box sx={{ p: 2 }}>
      <PageHeader title="Help" />

      <Paper variant="outlined" sx={{ p: { xs: 2.5, sm: 4 }, borderRadius: 1 }}>
        <Typography variant="body1">
          We&apos;re developing online help resources at the minute. In the meantime, if you would
          like help with your survey development, please contact Neil Anderson in the WHO
          Collaborating Centre (CC) at QUB.
        </Typography>
        <Link
          href={`mailto:${SUPPORT_EMAIL}`}
          sx={{
            mt: 2,
            display: "inline-flex",
            alignItems: "center",
            gap: 0.75,
            fontWeight: 600,
          }}
        >
          <EmailOutlinedIcon fontSize="small" aria-hidden="true" />
          {SUPPORT_EMAIL}
        </Link>
      </Paper>
    </Box>
  );
}
